<template>
  <div class="loginmodal editorial-auth signup-auth">
    <div class="joinwrap">
      <!--img class="jointopimg" src="@/assets/img/sign_up_icon.png"-->
      <div class="join-header">
        <img src="@/assets/img/mega-orbit-logo.svg" alt="MEGA" />
        <div>
          <strong>{{ $t('front.common.signup') }}</strong>
          <span>필수 정보를 정확하게 입력해 주세요</span>
        </div>
      </div>
      <div class="joininwrap">
        <div>
          <!-- <p class="jointtxt">{{ $t('front.signup.warning1') }}<br>{{ $t('front.signup.warning2') }}</p> -->
          <ul class="joinu">
            <li>{{ $t('front.common.memId') }}</li>
            <li><input type="text" :placeholder="$t('front.signup.memIdPlaceholder')" name="signupMemId" v-model="model.memId" :readonly="true" @focus="onFocus"></li>
          </ul>
          <ul class="joinu">
            <li>{{ $t('front.common.nickName') }}</li>
            <li><input type="text" :placeholder="$t('front.signup.nickNamePlaceholder')"  name="signupMemNick" v-model="model.memNick" ::readonly="true" @focus="onFocus"></li>
          </ul>
          <ul class="joinu">
            <li>{{ $t('front.common.password') }}</li>
            <li><input type="password" :placeholder="$t('front.signup.passwordPlaceholder')" name="signupMemName" v-model="model.memPass" :readonly="true" @focus="onFocus"></li>
          </ul>
          <ul class="joinu">
            <li>{{ $t('front.common.passwordCheck') }}</li>
            <li><input type="password" :placeholder="$t('front.signup.passwordPlaceholder')" v-model="model.memPassCheck" :readonly="true" @focus="onFocus"></li>
          </ul>
          <ul class="joinu">
            <li>{{ $t('front.common.cashOutPass') }}</li>
            <li><input id="cashOutPass" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" maxlength="4" :placeholder="$t('front.signup.cashOutPassPlaceholder')" pattern="[0-9]*" v-model="model.cashOutPass" inputmode="numeric" /></li>
          </ul>
        </div>
        <div>
          <ul class="joinu">
            <li>{{ $t('front.common.phone') }}</li>
    <!--        <li class="w100">-->
    <!--          <select v-model="model.memPhoneVendor">-->
    <!--            <option value="skt">SKT</option>-->
    <!--            <option value="kt">KT</option>-->
    <!--            <option value="lgu">LGU</option>-->
    <!--            <option value="sktmvno">SKT(알뜰폰)</option>-->
    <!--            <option value="ktmvno">KT(알뜰폰</option>-->
    <!--            <option value="lgumvno">LGU(알뜰폰)</option>-->
    <!--          </select>-->
    <!--        </li>-->
            <li><input type="text" :placeholder="$t('front.signup.phonePlaceholder')" v-model="model.memPhone"></li>
          </ul>
          <ul class="joinu">
            <li>{{ $t('front.common.recommandId') }}</li>
            <li v-if="!joinRecommenderId"><input type="text" :placeholder="$t('front.signup.recommandIdPlaceholder')" v-model="model.recommenderId"/></li>
            <li v-else>{{joinRecommenderId}}</li>
          </ul>
          <ul class="joinu bank">
            <li>{{ $t('front.common.bankAcc') }}</li>
            <li>
              <select v-model="model.bank" class="w100">
                <option selected :value="''" disabled>{{ $t('front.common.bankSelect') }}</option>
                <template v-for="item in bankList" v-bind:key="item.bankCode">
                  <option :value="item.bankCode" >{{ item.bankNameKr }}</option>
                </template>
              </select>
              <input type="text" :placeholder="$t('front.common.bankName')" v-model="model.memName">
              <input type="text" :placeholder="$t('front.common.bankAccOnlyNumber')" v-model="model.bankacc" oninput="this.value = this.value.replace(/[^0-9.]/g, '')">
            </li>
          </ul>
          <a class="loginnbtn on" @click="onSubmit">{{ $t('front.common.signup') }}</a>
        </div>
      </div>

      <!--ul class="snswrap" v-if="siteOption">
        <li><img src="@/assets/img/kakao.png"><span class="br">{{siteOption['sns2Id']}}</span></li>
        <li><img src="@/assets/img/tele.png"><span class="bl">{{siteOption['sns1Id']}}</span></li>
      </ul-->
      <div class="loginclose" @click="onClose"><img src="@/assets/img/icon_x.svg" /></div>
    </div>
  </div><!-- join -->
</template>

<script>

import { getBankList, signUp } from '@/api/member'
import { isValidOnlyNumber, isValidOnlyPhoneNumber, isValidPassword, isValidUserId } from '@/libs/utils'
import { mapState } from 'vuex'

export default {
  name: 'Join',
  computed: {
    ...mapState([
      'siteOption',
      'joinRecommenderId'
    ])
  },
  watch: {

  },
  created () {
    this.loadBankList()
  },
  methods: {
    loadBankList () {
      getBankList({}).then(response => {
        const result = response.data
        if (result.resultCode === '0') {
          const data = result.data
          this.bankList = data.list
        }
      })
    },
    isValidate () {
      const data = this.model
      for (const key of Object.keys(data)) {
        const value = data[key]
        if (key === 'memId') {
          if (value === '') {
            this.onAlert('warningart', 'front.member.emptyMemId')
            return false
          }

          if (!isValidUserId(value)) {
            this.onAlert('warningart', 'api.U101')
            return false
          }
        }

        if (key === 'memPassCheck') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.compareMemPass')
            return false
          }
        }

        if (key === 'memPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemPass')
            return false
          }

          if (!isValidPassword(value) || value.length > 20) {
            this.onAlert('warningart', 'api.U102')
            return false
          }
        }

        if (key === 'cashOutPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyCashOutPass')
            return false
          }

          if (!isValidOnlyNumber(value) || value.length !== 4) {
            this.onAlert('warningart', 'api.U103')
            return false
          }
        }

        if (key === 'memNick') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemName')
            return false
          }

          if (value.length > 20 || value.length < 2) {
            this.onAlert('warningart', 'api.U105')
            return false
          }
        }

        if (key === 'memPhone') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemTel')
            return false
          }

          if (!isValidOnlyPhoneNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidMemTel')
            return false
          }
        }

        if (key === 'recommenderId') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyRecommenderId')
            return false
          }
        }

        if (key === 'bank') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankName')
            return false
          }
        }

        if (key === 'memName') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankAccountName')
            return false
          }
        }

        if (key === 'bankacc') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankNumber')
            return false
          }

          if (!isValidOnlyNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidBankNumber')
            return false
          }
        }

        if (data.memPass !== data.memPassCheck) {
          this.onAlert('warningart', 'front.member.compareMemPass')
          return false
        }
      }

      return true
    },
    onClose () {
      this.$emit('close', false)
    },
    onSubmit (nextPageName) {
      if (this.isValidate()) {
        this.model.memPhone = this.model.memPhone.toString()
        signUp(this.model).then(async response => {
          const result = response.data
          if (result.resultCode === '0') {
            await this.onCheck('front.member.completeSignup')
            if (nextPageName && typeof nextPageName === 'string') {
              this.goPageByName(nextPageName)
            } else {
              this.$emit('close', true)
            }
          } else {
            this.onAlert('warningart', 'api.' + result.resultCode)
          }
        }).catch(err => {
          console.error('singup err : ', err)
        })
      }
    }
  },
  data () {
    return {
      bankList: [],
      checkMemPass: '',
      model: {
        siteName: '',
        siteType: '',
        ip: '',
        apiKey: '',
        memId: '',
        memPass: '',
        memPassCheck: '',
        memPhone: '',
        memPhoneVendor: '',
        memLevel: '1',
        bank: '',
        memName: '',
        memNick: '',
        bankacc: '',
        cashOutPass: '',
        nationCode: '',
        partSendYn: 'N',
        recommenderId: '',
        partnerType: '',
        memStatus: 0
      }
    }
  }
}
</script>

<style scoped>
#cashOutPass {
  -webkit-text-security: disc;
}
</style>

<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>

<style scoped>
.editorial-auth {padding:24px;background:rgba(5,5,6,.82);backdrop-filter:blur(6px);box-sizing:border-box}
.signup-auth .joinwrap {width:680px;max-width:680px;margin:0;padding:0;border:1px solid #34312d;border-radius:10px;background:#141416;background-image:none;box-shadow:0 24px 70px rgba(0,0,0,.55);overflow:hidden}
.join-header {height:72px;padding:0 24px;border-bottom:1px solid #29292d;display:flex;align-items:center;gap:17px;box-sizing:border-box}
.join-header>img {width:116px;height:auto}
.join-header>div {display:flex;flex-direction:column;gap:5px}
.join-header strong {color:#eeeae6;font-size:17px}
.join-header span {color:#77736f;font-size:9px}
.signup-auth .joininwrap {padding:8px 24px 22px;border-radius:0;background:#141416;box-shadow:none;display:grid;grid-template-columns:1fr 1fr;gap:0 20px}
.signup-auth .joinu {gap:5px;margin-top:12px}
.signup-auth .joinu li:first-child {color:#a9a49e;font-size:10px}
.signup-auth .joinu li {font-size:11px}
.signup-auth .joinu input,.signup-auth .joinu select {height:40px;padding:0 12px;border:1px solid #302f30;border-radius:6px;background:#101012;box-shadow:none;color:#eeeae6;font-size:11px;outline:none;text-align:left}
.signup-auth .joinu input::placeholder {color:#66635f}
.signup-auth .joinu input:focus,.signup-auth .joinu select:focus {border-color:#806b42;background:#111113}
.signup-auth .joinu.bank li+li {display:grid;grid-template-columns:92px 1fr 1.35fr;gap:5px}
.signup-auth .joinu.bank li+li select,.signup-auth .joinu.bank li+li input {width:100%}
.signup-auth .loginnbtn.on {height:40px;margin-top:17px;border:1px solid #8a7042;border-radius:6px;background:#8a7042;box-shadow:none;color:#f7f3eb;font-size:12px;line-height:40px;text-shadow:none}
.signup-auth .loginnbtn.on:hover {background:#9a8050}
.signup-auth .loginclose {right:16px;top:16px}
.signup-auth .loginclose img {width:18px;height:18px;opacity:.55}
@media (max-width:720px) {
  .editorial-auth {padding:12px;align-items:flex-start;overflow-y:auto}
  .signup-auth .joinwrap {width:100%;max-width:420px;margin:12px auto}
  .signup-auth .joininwrap {display:block;padding:8px 18px 22px}
  .join-header {height:66px;padding:0 18px}
  .signup-auth .joinu.bank li+li {grid-template-columns:1fr}
}
</style>
